$(document).ready( function() {

	var special_scroll_threshold	= 0;
	var delta_nav_height			= 0;
	var special_sticky_offset		= 0;
	var lazy_threshold				= window.innerHeight;
	var bool_special				= $('.main-navi-arrow .arrow').length;

	// Threshold for lazy-loading is device-height
	$(":not(.whcaptcha) img").unveil(lazy_threshold);

	// Titdedetailseite --> Beschreibungstext erweitern bei Click.
	$("#show-longtext").click(function() {
		$("#description-text").toggleClass("short-version");
		$("#ml-detail-link-less").toggleClass("hidden");
		$("#ml-detail-link").toggleClass("hidden");
	});

	$('.button-expand-main').click(function() {
		var $this = $(this);

		// Toggle indicator arrow
		$this.toggleClass('fa-chevron-down');

		// Next sibling = expand-body
		$this.parent().next().toggle();
	});

	$('.button-expand-meta').click(function() {
		var $this = $(this);

		// Toggle indicator arrow
		$this.toggleClass('fa-chevron-down');

		// Next sibling = expand-body
		$this.parent().next().toggle();
	});

	// Hide every expand-box initially
	/*
	$('.button-expand-main').each(function(index) 	{
		var $this = $(this);

		// Toggle indicator arrow
		$this.addClass('fa-chevron-down');

		// Next sibling = expand-body
		$this.parent().next().hide();
	});
	*/

	// Specialmenu - change arrow if clicked
	$('.main-navi-arrow i').click(function() {
		$('.main-navi-arrow i').toggleClass('hidden');
	});
	// animation for special header menu on hover (desktop only)
	/*
	if ($(window).width() > 960) {
		$(".main-navi-arrow .arrow").hover(function(){
			$(this).find(".arrow-box").animate({ "height": '+=10px'}, "fast");
			$("#nav_default img").trigger("unveil");
		}, function(){
			$(this).find(".arrow-box").animate({ "height": '-=10px'}, "fast");
		});
	}
	*/

	$('.button-expand-meta').each(function(index) {
		var $this = $(this);

		// Toggle indicator arrow
		$this.addClass('fa-chevron-down');

		// Next sibling = expand-body
		$this.parent().next().hide();
	});

	init_menu();

	// SPECIAL NAVIGATION +++++++++++++++++++++++++++++++++++
	// Show mobile sidebar
	$('.navbar-mega-menu .row #special_menu_button,.navbar-mega-menu .row #special_menu_button_sticky').click(function()
	{
		$('.special-navbar-mobile').show();
	});

	// Hide mobile sidebar
	$('.special-navbar-mobile .button-close,.special-navbar-mobile .button-close').click(function()
	{
		$('.special-navbar-mobile').hide();
	});

	// $(".mega-menu-container").each(function() { /* $(this).css("width", $(window).width()-30);*/ });

	if ( typeof active_content_id_string != 'undefined' ) {
		$('#link_'			+ active_content_id_string).addClass('active').closest("li").addClass("active");
		$('#sticky_link_'	+ active_content_id_string).addClass('active').closest("li").addClass("active");
	}
	if ( typeof active_special_id_string != 'undefined' ) {
		$('#link_'			+ active_special_id_string).addClass('active').closest("li").addClass("active");
	}

	// hide overlay on click
	$("button[name=kill-overlay]").click(function() { $('#warenkorb-overlay').hide(); });

	/********************************************/
	/* Typeahead auf leeren Suchstring pruefen  */
	/********************************************/
	$("#search_xs").click(function() {
		$('#search_xs-input').toggleClass('hidden');
	});

	$("#search_xs-sticky").click(function() {
		$('#search_xs-input-sticky').toggleClass('hidden');
	});

	$("#search_sticky").click(function() {
		$('#search_sticky-input').toggleClass('hidden');
	});
	$("#search_sticky_xs").click(function() {
		$('#search_sticky-input-xs').toggleClass('hidden');
	});

	$(".btn-search").click(function () {
		// Suchschlitz für mobile Devices
		var c = $(this).closest(".row").find("input").val();
		if (c === undefined) {
			// normaler Suchschlitz für normale Devices
			c = $(this).prev().val();
		}

		if (c === "" || c == "Suche") {
			alert("Bitte geben Sie einen Suchbegriff ein!");
			return false;
		}
		return true;
	});

	/********************************************/
	/*			Polylines for meta-navi			*/
	/********************************************/
	$("li.dropdown:not(.no-hover)").hover(
		function(){
			$("li.dropdown:hover > a").css({
				"border"		: "1px solid rgba(255,255,255,0)",
				"border-top"	: "1px solid rgba(0,0,0,0.2)",
				"border-right"	: "1px solid rgba(0,0,0,0.2)",
				"border-left"	: "1px solid rgba(0,0,0,0.2)",
				"background"	: "white",
				"position"		: "relative",
				"z-index"		: "10",
				"border-radius"	: "0"
			});
		}
		,
		function(){
			$("li.dropdown:hover > a").css({
				"border"		: "1px solid rgba(255,255,255,0)",
				"background"	: "none",
				"position"		: "relative",
				"z-index"		: "10",
				"border-radius"	: "0"
			});

			$("li.dropdown > a").css({
				"border"		: "1px solid rgba(255,255,255,0)",
				"background"	: "none",
				"position"		: "relative",
				"z-index"		: "10",
				"border-radius"	: "0"
			});
		}
	);

	/********************************************/
	/* Slick-Slider								*/
	/********************************************/

	// Titelslider
	$('.slider-container').on('afterChange', function(event,slick,currentSlide,nextSlide){
		$(":not(.whcaptcha) img").unveil(lazy_threshold);
	});
	$(".slider-container").slick({
		slidesToShow:	5,
		slidesToScroll: 5,
		infinite:		false,
		swipeToSlide:	true,
		arrows:			true,
		responsive: [
			{
				breakpoint: 480,
					settings: {
						slidesToShow:	1,
						slidesToScroll:	1,
						arrows:			true,
						swipeToSlide:	true
					}
			},
			{
				breakpoint: 768,
					settings: {
						slidesToShow:	2,
						slidesToScroll:	2,
						arrows:			true,
						swipeToSlide:	true
					}
			},
			{
				breakpoint: 992,
					settings: {
						slidesToShow:	3,
						slidesToScroll:	3,
						arrows:			true
					}
			},
			{
				breakpoint: 1200,
					settings: {
						slidesToShow:	4,
						slidesToScroll:	4,
						arrows:			true
					}
			}
		]
	});

	// Moodbar
	$("#moodbar-slider").slick({
		slidesToShow:	1,
		slidesToScroll:	1,
		autoplay:		true,
		autoplaySpeed:	7000,
		lazyLoad:		'ondemand',
		dots:			true,
		arrows:			false
	});

	// Für Target_blank HTML-konform
	$("area.external, a[rel=external]").attr("target", "_blank");
	$("a[rel=top]").attr("target", "_top");
	$("a[rel=self]").attr("target", "_self");

	// Teaser Resize Function Call
	teaser_resize();

	// scroll-threshold for specials = (moodbar) ? moodbar + navbar : moodbar-replacement + navbar;
	scroll_th					= init_threshold();
	special_scroll_threshold	= init_special_offset();

	// Windows Resize Function
	$(window).resize(function() {
		teaser_resize();
		/* Threshold for lazy-loading is device-height */
		lazy_threshold				= window.innerHeight;
		scroll_th					= init_threshold();
		special_scroll_threshold	= init_special_offset();
	});

	try {
		load_typeahead(request_typeahead_string,active_page_id);
	} catch(e) {
		// wako with no navigation part => no search needed.
		// console.error("typeahead");
	}

	$('.main-navi-arrow .arrow').click(function() {
		$('#logo_kunstmann img').trigger('unveil');
		$('#nav_default').slideToggle('slow',function() {
			delta_nav_height = $('#nav_default').height();
			if ( $('#nav_default:visible').height() !== undefined && $('#nav_default:visible').height() != null) {
				special_scroll_threshold += delta_nav_height;
				try {
					load_typeahead(request_typeahead_string,active_page_id);
				} catch(e) {
					// wako with no navigation part => no search needed.
					// console.error("typeahead error");
				}
			} else {
				special_scroll_threshold = init_special_offset();
			}
		});
	});

	// Sticky Navbar & Top-Button
	$(window).bind('scroll', function () {
		special_sticky_offset = init_sticky_offset(special_scroll_threshold);
		$('#sticky-nav').css("top",special_sticky_offset+"px");
		$('#sticky-nav-mobile').css("top",special_sticky_offset+"px");
		$('.mega-menu-container').css("top",(special_sticky_offset+50)+"px");

		// no sticky main-navi if special-page
		if ($(window).scrollTop() > scroll_th && bool_special === 0) {
			$('#sticky-nav').css("display","block");
			$('#sticky-nav-mobile').css("display","block");
			$(".totop").show();
		} else {
			$('#sticky-nav').css("display","none");
			$('#sticky-nav-mobile').css("display","none");
			$(".totop").hide();
		}
	});

	// Fancybox Versandkosten
	$(".fancybox-wako").fancybox({
		helpers: {
			title: {
				type: null
			}
		}
		,ajax: {
			dataType: 'html'
			,headers: null
		}
		,iframe: {
			scrolling: 'yes'
			,preload: true
		}
		,autoScale: true
		,arrows: false
		,closeEffect: 'elastic'
		,closeSpeed: 450
		,openEffect: 'elastic'
		,openSpeed: 450
		,overlayColor: '#EEE'
		,scrolling: 'no'
		,scrollOutside: true
		,showNavArrows: false
		,title: null
		,titleShow: false
		,type: 'iframe'
		,width: 600
		,height: 600
	});

	for (i = 0; i < array_werbemittel.length; i++) {
		item = "item_" + array_werbemittel[i];
		$("#"+item).fancybox({
			helpers: {
				title: {
					type: null
				}
			}
			,openSpeed: 450
			,closeSpeed: 450
			,openEffect: 'elastic'
			,closeEffect: 'elastic'
		});
	}


	/********************************************/
	/*			List / Matrix Switches			*/
	/********************************************/
	init_switches();

	// init load all titlelist
	load_all_init();

	/********************************************/
	/*	init select chosen 						*/
	/********************************************/
	chosen_init();
	$(".chosen-single > div b").html("<i class='fa fa-angle-down fa-lg'></i>");

	// Overlay schnellansicht
	init_quickview();

	// Pressestimmen
	$("#pressetimmen_all").click(function() {
		$(".extra_pressestimmen").slideDown("slow");
		$("#pressetimmen_all").css("display","none");
		$("#pressetimmen_less").css("display","block");
	});
	$("#pressetimmen_less").click(function() {
		$(".extra_pressestimmen").slideUp("slow");
		$("#pressetimmen_all").css("display","block");
		$("#pressetimmen_less").css("display","none");
	});

	$(".news-langtext-more-link").click(function() {
		var news_body = $(this).closest(".news-langtext-container").find(".text-body");
		var link_hide = $(this).closest(".news-langtext-container").find(".news-langtext-close-link");
		var link_show = $(this).closest(".news-langtext-container").find(".news-langtext-more-link");
		$(news_body).slideDown("slow");
		$(link_show).css("display","none");
		$(link_hide).css("display","block");
	});

	$(".news-langtext-close-link").click(function() {
		var news_body = $(this).closest(".news-langtext-container").find(".text-body");
		var link_hide = $(this).closest(".news-langtext-container").find(".news-langtext-close-link");
		var link_show = $(this).closest(".news-langtext-container").find(".news-langtext-more-link");
		$(news_body).slideUp("slow");
		$(link_show).css("display","block");
		$(link_hide).css("display","none");
	});

	// Eventlist
	check_events();

	// AddThis
	// init_addthis();
});

// after ajax
$( document ).ajaxComplete(function( event, xhr, settings ) {
	var lazy_threshold	= window.innerHeight;
	$(":not(.whcaptcha) img").unveil(lazy_threshold);

	/********************************************/
	/*				Wako-Overlay				*/
	/********************************************/
	$("button[name=kill-overlay]").click(function(){
		$('#warenkorb-overlay').hide();
	});

	// Overlay schnellansicht
	init_quickview();
	// init_addthis();
});

function load_typeahead(th_string,p_id) {
	init_typeahead('.search-input-sticky',		th_string,	p_id);
	init_typeahead('.search-input-xs-sticky',	th_string,	p_id);
	init_typeahead('.search-input-md-sticky',	th_string,	p_id);
	init_typeahead('.search-input-xs',			th_string,	p_id);
	init_typeahead('.search-input-md',			th_string,	p_id);
	init_typeahead('#search-meta',				th_string,	p_id);
}

function init_typeahead(selector,string,id) {
	/* default options */
	var top				= 0;
	var right			= 0;
	var width			= "0px";
	var page_id			= id;
	var defaultstring 	= string;
	var container		= "";
	var id_add			= "";
	switch(selector) {
		case '.search-input-sticky':
			top				= 18;
			right			= -8;
			container		= ".typeahead-container-sticky";
			width 			= "120%";
			id_add			= "_sticky";
			break;
		case '.search-input-xs-sticky':
			top				= 24;
			right			= 0;
			container		= ".typeahead-container-xs-sticky";
			width 			= "100%";
			id_add			= "_mobile_xs_sticky";
			break;
		case '.search-input-md-sticky':
			top				= 18;
			right			= 17;
			container		= ".typeahead-container-md-sticky";
			width 			= "120%";
			id_add			= "_mobile_md_sticky";
			break;
		case '.search-input-xs':
			top				= 24;
			right			= 0;
			container		= ".typeahead-container-xs";
			width 			= "120%";
			id_add			= "_mobile_xs";
			break;
		case '.search-input-md':
			top				= 18;
			right			= 2;
			container		= ".typeahead-container-md";
			width 			= "5px";
			id_add			= "_mobile_md";
			break;
		default:
			// check first form-group width and position
			container_width	= $(".typeahead-container").innerWidth();
			form_group_el	= $(selector).closest('.form-group').find('.input-group');
			input_width		= $(form_group_el).innerWidth();
			top				= 20;
			right			= (container_width-input_width)/2+58;
			container		= ".typeahead-container";
			width 			= "27px";
	}
	/* get page_id and defaultstring */
	$(selector).wh_typeahead({
		ajaxurl:		"/ajax/suche"
		,page_id:		page_id
		,width:			width
		,top:			top
		,right:			right
		,container:		container
		,defaultstring:	defaultstring
		,id_add:		id_add
	});
}

/* load titlelist init */
function load_all_init() {
	$('.load-all-titles').click(function() {
		var widget_id		= $(this).closest('.widget_titel_titelliste').attr('id');
		var darstellung		= $(this).closest('.widget_titel_titelliste').find("input[name=darstellung]").val();
		load_ajax_titelliste(widget_id, $(this), darstellung, 0, 0);
	});
	$('.load-all-events').click(function() {
		var widget_id		= $(this).closest('.widget_events').attr('id');
		load_ajax_eventliste(widget_id, $(this), 0, 0, true);
	});
	$('.load-less-events').click(function() {
		var widget_id		= $(this).closest('.widget_events').attr('id');
		load_ajax_eventliste(widget_id, $(this), 1, 3, false);
		console.log("scroll");
		scroll_View('#widget_veranstaltung_suche_liste_events');
	});
}

function scroll_View(elem) {
	return $(elem).each(function () {
		$('html, body').animate({
			scrollTop: $(this).offset().top
		}, 1000);
	});
}

/********************************************/
/*	Titlelist								*/
/********************************************/
function load_ajax_titelliste(id_string, this_elem, darstellung, nachladen_box, anzahl) {
	//formular definieren
	var form_elem		= $(this_elem).closest("form");
	var position_start	= id_string.search('_');
	var id				= id_string.substr(position_start+1);
	var url				= "";
	//loader image
	//$(form_elem).find('.loader-filter').show();

	//filter an url anhängen
	var filter_header		= $(".filter-wrapper").length;
	if (filter_header === 0) {
		url					= $(form_elem).find("input[name=url_no_filter_" + id + "]").val();
	} else {
		url					= $(form_elem).find("input[name=url_" + id + "]").val();
		var sortierung		= $(form_elem).find("select[name=titlelist-sort] option:checked").val();
		url					+= "&sortierung="			+ sortierung;
	}
	var filter 				= $(form_elem).find("select[name=titlelist-filter] option:checked").val();
	var thema_ids			= $(form_elem).find("input[name=thema_ids]").val();
	var produktgruppen_ids	= $(form_elem).find("input[name=produktgruppen_ids]").val();
	var programmsegment_ids	= $(form_elem).find("input[name=programmsegment_ids]").val();
	var neuerscheinung		= $(form_elem).find("input[name=neuerscheinung]").val();
	var pressesuche			= $(form_elem).find("input[name=pressesuche]").val();
	var foreign_rights		= $(form_elem).find("input[name=foreign_rights]").val();
	var bereich_ids 		= $(form_elem).find("input[name=bereich_ids]").val();
	var ebooks_filter 		= $(form_elem).find("input[name=ebooks_filter]").val();

	if (bereich_ids === undefined) {
		bereich_ids = 0;
	}
	if (filter === undefined) {
		filter = bereich_ids;
		if (filter === undefined) {
			filter = "";
		}
	}
	if (neuerscheinung === undefined) {
		neuerscheinung = 0;
	}
	if (thema_ids === undefined) {
		thema_ids = "";
	}
	if (programmsegment_ids === undefined) {
		programmsegment_ids = "";
	}
	if (produktgruppen_ids === undefined) {
		produktgruppen_ids = "";
	}
	if (pressesuche === undefined) {
		pressesuche = 0;
	}
	if (foreign_rights === undefined) {
		foreign_rights = 0;
	}

	if (ebooks_filter === undefined) {
		ebooks_filter = 2;
	}

	url				+= "&darstellung="			+ darstellung;
	url				+= "&nachladebox="			+ nachladen_box;
	url				+= "&anzahl="				+ anzahl;
	url				+= "&filter="				+ filter;
	url				+= "&bereich_ids="			+ bereich_ids;
	url				+= "&thema_ids="			+ thema_ids;
	url				+= "&produktgruppen_ids="	+ produktgruppen_ids;
	url				+= "&programmsegment_ids="	+ programmsegment_ids;
	url				+= "&neuerscheinung="		+ neuerscheinung;
	url				+= "&pressesuche="			+ pressesuche;
	url				+= "&foreign_rights="		+ foreign_rights;
	url				+= "&ebooks_filter="		+ ebooks_filter;

	// AJAX request
	var liste_body = $('#'+id_string).find(".widget_body");
	$(liste_body).load(url,function(){
		load_all_init();
	});
}

/********************************************/
/*	Eventlist								*/
/********************************************/
function load_ajax_eventliste(id_string, this_elem, nachladen_box, anzahl, hide) {
	hide	= (typeof hide === 'undefined') ? false : hide;

	// widget as widget
	var form_elem		= $(this_elem).closest("form");
	var position_start	= id_string.search('_');
	var id				= id_string.substr(position_start+1);
	var url				= $('#'+id_string).find("input[name=url_" + id + "]").val();
	var personen_ids	= $('#'+id_string).find("input[name=personen_ids]").val();
	var event_ids		= $('#'+id_string).find("input[name=event_ids]").val();
	var author			= "";
	var location		= "";
	var time			= 0;
	if (form_elem !== undefined) {
		author			= $(form_elem).find("select[name=autor] option:checked").val();
		location		= $(form_elem).find("select[name=ort] option:checked").val();
		time			= $(form_elem).find("select[name=zeitraum] option:checked").val();
		if (author === undefined) {
			author = "";
		}
		if (location === undefined) {
			location = "";
		}
		if (time === undefined) {
			time = 0;
		}
	}
	url				+= "&nachladenbox="			+ nachladen_box;
	url				+= "&anzahl="				+ anzahl;
	url				+= "&autor="				+ author;
	url				+= "&ort="					+ location;
	url				+= "&datum="				+ time;
	if (personen_ids !== "") {
		url			+= "&personen_ids="			+ personen_ids;
	}
	if (event_ids !== "") {
		url			+= "&event_ids="			+ event_ids;
	}
	if (hide) {
		url			+= "&hide=true";
	}
	// AJAX request
	var liste_body = $('#'+id_string).find(".event-list-container");
	$(liste_body).load(url,function(){
		load_all_init();
	});
}

/********************************************/
/*				Chosen Select	 			*/
/********************************************/
function chosen_init() {
	/* Titlelist */
	$('.titlelist-filter').chosen({
		width:						'100%'
		,disable_search:			true
		,inherit_select_classes:	true
	}).change(function(e){
		var fieldset		= $(this).closest('.widget-header').next();
		var darstellung		= $(fieldset).find("input[name=darstellung]").val();
		var nachladen_box	= $(fieldset).find("input[name=nachladebox]").val();
		var anzahl			= $(fieldset).find("input[name=anzahl]").val();
		var widget_id		= $(fieldset).find("input[name=widget_id]").val();
		load_ajax_titelliste('widget_' + widget_id, $(this), darstellung, nachladen_box, anzahl);
	});

	$('.titlelist-sort').chosen({
		width:						'100%'
		,disable_search:			true
		,inherit_select_classes:	true
	}).change(function(e){
		var fieldset		= $(this).closest('.widget-header').next();
		var darstellung		= $(fieldset).find("input[name=darstellung]").val();
		var nachladen_box	= $(fieldset).find("input[name=nachladebox]").val();
		var anzahl			= $(fieldset).find("input[name=anzahl]").val();
		var widget_id		= $(fieldset).find("input[name=widget_id]").val();
		load_ajax_titelliste('widget_' + widget_id, $(this), darstellung, nachladen_box, anzahl);
	});

	$('.land-select').chosen({
		width:						'100%'
		,disable_search:			true
		,inherit_select_classes:	true
		,placeholder_text_single:	'&nbsp;'
	});
	$('.eventlist-filter-location').chosen({
		width:						"100%"
		,disable_search:			true
		,inherit_select_classes:	true
	}).change(function(e){
		var url				= $(this).closest('form').find("input[name=event_page_url]").val();
		load_meta_events($(this),url);
	});
	$('.eventlist-filter-title').chosen({
		width:						"100%"
		,disable_search:			true
		,inherit_select_classes:	true
	});
	$('.eventlist-filter-author').chosen({
		width:						"100%"
		,disable_search:			true
		,inherit_select_classes:	true
	}).change(function(e){
		var url				= $(this).closest('form').find("input[name=event_page_url]").val();
		load_meta_events($(this),url);
	});
	$('.eventlist-filter-time').chosen({
		width:						"100%"
		,disable_search:			true
		,inherit_select_classes:	true
	}).change(function(e){
		var url				= $(this).closest('form').find("input[name=event_page_url]").val();
		load_meta_events($(this),url);
	});
}

function load_meta_events(this_elem, url) {
	// widget via event-overview
	// AJAX request
	var form_elem		= $(this_elem).closest("form");
	var list_body		= $(form_elem).find('.result');
	var fieldset		= $(form_elem).find('.widget_events');
	var widget_id		= $(fieldset).find("input[name=widget_id]").val();
	var author			= "";
	var location		= "";
	var time			= 0;
	if (form_elem !== undefined) {
		author			= $(form_elem).find("select[name=autor] option:checked").val();
		location		= $(form_elem).find("select[name=ort] option:checked").val();
		time			= $(form_elem).find("select[name=zeitraum] option:checked").val();
		if (author === undefined) {
			author = "";
		}
		if (location === undefined) {
			location = "";
		}
		if (time === undefined) {
			time = 0;
		}
	}

	url				+= "?autor="				+ author;
	url				+= "&ort="					+ location;
	url				+= "&datum="				+ time;
	$(list_body).load(url,function(){
		load_all_init();
	});
}

/**
 * Blendet das Overlay der Reihendetailansicht (Cover) ein
 */
function show_overlay() {
	try {
		$(this).find('.quick-overlay').css("display", "block");
	} catch (e) {}
}

/**
 * Blendet das Overlay der Reihendetailansicht (Cover) aus
 */
function hide_overlay() {
	try {
		$(this).find('.quick-overlay').css("display", "none");
	} catch (e) {}
}

/********************************************/
/*	Teaser									*/
/********************************************/
function teaser_resize() {
	$(".widget-teaser-big img").each(function() {
		switch_sizes($(this));
	});
}

function switch_sizes(elem) {
	var classes	= elem.attr("class");
	var rex_lg	= /lg-\S+/;
	var rex_md	= /md-\S+/;
	var rex_sm	= /sm-\S+/;
	if ($(window).width() <= 550) {
		if ( $.inArray("sm-jpg",classes.split(" ")) > -1 || $.inArray("sm-png",classes.split(" ")) > -1 ) {
			elem.attr("src",elem.attr("src").replace("/l/","/s/"));
			elem.attr("src",elem.attr("src").replace("/m/","/s/"));
			elem.attr("src",adjust_filename(elem.attr("src"),classes.match(rex_sm)[0]));
		}
	} else if ($(window).width() > 550 && $(window).width() <= 975) {
		if ($.inArray("md-jpg",classes.split(" ")) > -1 || $.inArray("md-png",classes.split(" ")) > -1 ) {
			elem.attr("src",elem.attr("src").replace("/l/","/m/"));
			elem.attr("src",elem.attr("src").replace("/s/","/m/"));
			elem.attr("src",adjust_filename(elem.attr("src"),classes.match(rex_md)[0]));
		}
	} else {
		if ($.inArray("large",classes.split(" ")) > -1) {
			elem.attr("src",elem.attr("src").replace("/m/","/l/"));
			elem.attr("src",elem.attr("src").replace("/s/","/l/"));
			elem.attr("src",adjust_filename(elem.attr("src"),classes.match(rex_lg)[0]));
		} else if ($.inArray("medium",classes.split(" ")) > -1) {
			elem.attr("src",elem.attr("src").replace("/l/","/m/"));
			elem.attr("src",elem.attr("src").replace("/s/","/m/"));
			elem.attr("src",adjust_filename(elem.attr("src"),classes.match(rex_md)[0]));
		}
	}
}

function adjust_filename (src,pattern) {
	var pat_length	= pattern.length;
	var ext_old		= src.match(/[^\.]+$/)[0];
	var ext_new		= pattern.substring(3, pat_length);
	src				= src.replace(ext_old,ext_new);
	return src;
}

function filter_authors(e) {
	var form			= $(e).closest('form');
	var ordinale		= $(e).val();
	var url				= form.find("input[name=url]").val();
	var personen_ids	= form.find("input[name=personen_ids]").val();
	var pl_filter		= form.find("input[name=pl_filter]").val();
	if (personen_ids === undefined) {
		personen_ids = "";
	}
	url					+= "&filter="		+ ordinale;
	url					+= "&personen_ids="	+ personen_ids;
	url					+= "&pl_filter="	+ pl_filter;
	// AJAX request
	var liste_body = $(e).closest('.widget-authors').find(".list-body");
	$(liste_body).load(url,function(){
		$('.btn-authors').removeClass('active');
		$('#authors_'+ordinale).addClass('active');
	});
}

function init_quickview() {
	$('.image-container').hoverIntent({
		over:		show_overlay,
		timeout:	50,
		out:		hide_overlay
	});
	$('.cover-container').hoverIntent({
		over:		show_overlay,
		timeout:	50,
		out:		hide_overlay
	});
}

/**
 * this function creates the necessary addthis include-code before the body-element
 * it includes the customers ID
 */
function init_addthis(){
	jQuery('.sharing.inactive').click(function(){
		var addthisScript = document.createElement('script');
		addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-59140f6b8cb2bc30');
		document.body.appendChild(addthisScript);
		$('.sharing.inactive').hide();
		$('.share-button').hide();
	});
}

function init_menu() {
	// Show mobile sidebar
	$('.navbar-mega-menu .row #menu_button,.navbar-mega-menu .row #menu_button_sticky').click(function()
	{
		$('.navbar-mobile').show();
	});

	// Hide mobile sidebar
	$('.navbar-mobile .button-close,.navbar-mobile .button-close').click(function()
	{
		$('.navbar-mobile').hide();
	});
}

function init_threshold() {
	var scroll_threshold = 0;
	// Threshold for scroll
	scroll_threshold	= $('.navbar.navbar-default.header').height();
	scroll_threshold	-= $('.container-nav-meta').height();
	$("#logo_kunstmann img").unveil(400, function() {
		scroll_threshold	= $('.navbar.navbar-default.header').height();
		scroll_threshold	-= $('.container-nav-meta').height();
	});
	return scroll_threshold;
}

function init_switches() {
	$('.list-switch').click(function() {
		$(this).closest(".switches").find(".list-switch").addClass('switch-list-active');
		$(this).closest(".switches").find(".list-switch").removeClass('switch-list');
		$(this).closest(".switches").find(".matrix-switch").addClass('switch-matrix');
		$(this).closest(".switches").find(".matrix-switch").removeClass('switch-matrix-active');

		var widget_id		= $(this).closest('.widget_titel_titelliste').attr('id');
		var nachladen_box	= $(this).closest('.widget_titel_titelliste').find("input[name=nachladebox]").val();
		var anzahl			= 0;
		anzahl				= $(this).closest('.widget_titel_titelliste').find("input[name=anzahl]").val();
		/* Ajax-Aufruf */
		if (anzahl === undefined || anzahl === 0) {
			anzahl			= parseInt($("input[name=anzahl]").val());
		}
		load_ajax_titelliste(widget_id, $(this), 'liste', nachladen_box, anzahl);
	});
	$('.matrix-switch').click(function() {
		$(this).closest(".switches").find(".list-switch").addClass('switch-list');
		$(this).closest(".switches").find(".list-switch").removeClass('switch-list-active');
		$(this).closest(".switches").find(".matrix-switch").addClass('switch-matrix-active');
		$(this).closest(".switches").find(".matrix-switch").removeClass('switch-matrix');

		var widget_id		= $(this).closest('.widget_titel_titelliste').attr('id');
		var nachladen_box	= $(this).closest('.widget_titel_titelliste').find("input[name=nachladebox]").val();
		var anzahl			= 0;
		anzahl				= $(this).closest('.widget_titel_titelliste').find("input[name=anzahl]").val();
		/* Ajax-Aufruf */
		if (anzahl === undefined || anzahl === 0) {
			anzahl			= parseInt($("input[name=anzahl]").val());
		}
		load_ajax_titelliste(widget_id, $(this), 'matrix', nachladen_box, anzahl);
	});
}

function check_events() {
	// check if events are preselected
	var event_form	= $('#event-formular');
	if (event_form !== undefined) {
		author		= $(event_form).find("select[name=autor]").val();
		if (author !== undefined && author !== "") {
			$(".eventlist-filter-author").trigger("change");
		}
		event_loc	= $(event_form).find("select[name=ort]").val();
		if (event_loc !== undefined && event_loc !== "") {
			$(".eventlist-filter-location").trigger("change");
		}
		time		= $(event_form).find("select[name=datum]").val();
		if (time !== undefined && time !== "") {
			$(".eventlist-filter-time").trigger("change");
		}
	}
}

function init_sticky_offset(s_scroll_th) {
	var special_offset = 0;
	if ($(window).scrollTop() > s_scroll_th) {
		special_offset = $('#sticky-special-nav').height();
		$('#sticky-special-nav').css("display","block");
		$('#sticky-special-nav-mobile').css("display","block");
	} else {
		special_offset = 0;
		$('#sticky-special-nav').css("display","none");
		$('#sticky-special-nav-mobile').css("display","none");
	}
	return special_offset;
}

function init_special_offset() {
	var s_scroll_th = 0;
	if ( $('.moodbar-replacer').height() !== undefined && $('.moodbar-replacer').height() !== null ) {
		s_scroll_th = $('.moodbar-replacer').height();
	} else {
		s_scroll_th = $('.widget-moodbar').height();
	}
	s_scroll_th += $('#special-navigation').height();
	return s_scroll_th;
}

function decryptThis(s) {
	var n=0;
	var r="";
	for(var i=0;i<s.length;i++) {
		n=s.charCodeAt(i);
		if (n>=8364) {n = 128;}
		r += String.fromCharCode(n-(2));
	}
	return r;
}

function decrypt_mail(element, email, params) {
	if (!params) var params = '';
	element.href = 'mailto:' + decryptThis(email) + params;
}

/**
 * Sets the optout option of Facebook's pixel tracking.
 */
function set_fb_optout() {
	window.localStorage.setItem("fb_optout", true);
}

// Anchor "smooth" Slide
function anchor_slide(elementId) {
	var anchor = document.getElementById(elementId);
	anchor.scrollIntoView({behavior:"smooth",block:"center"});
}